import { api } from "@/lib/api";

export interface EstimateHistoryEntry {
	id: string;
	estimated_time: number;
	created_at: string;
	updated_at: string;
	sprint: {
		id: string;
		name: string;
		start_date: string | null;
		end_date: string | null;
	} | null;
}

export async function getTaskEstimateHistory(
	projectId: string,
	taskId: string,
): Promise<EstimateHistoryEntry[]> {
	const res = await api.get<{ success: boolean; data: EstimateHistoryEntry[] }>(
		`/projects/${projectId}/tasks/${taskId}/estimate-history`,
	);
	return res.data ?? [];
}

export async function updateTaskSprintEstimate(
	projectId: string,
	taskId: string,
	estimateId: string,
	sprintId: string,
): Promise<EstimateHistoryEntry> {
	const res = await api.patch<{ success: boolean; data: EstimateHistoryEntry }>(
		`/projects/${projectId}/tasks/${taskId}/estimate-history/${estimateId}`,
		{ sprint_id: sprintId },
	);
	return res.data;
}
